import React from 'react';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

const AddressToolTip = () => {
  return (
    <section>
      <p className="pb-3 text-sm font-semibold leading-5">{mapLocaleToMeaningfulFormat().titleAddressTooltip}</p>
      <p className="pb-2 text-sm font-normal leading-4">{mapLocaleToMeaningfulFormat().instructionAddressTooltip}</p>
      <ol className="list-decimal pl-6">
        <li className="pb-2 leading-4">{mapLocaleToMeaningfulFormat().step1AddressTooltip}</li>
        <li className="pb-2 leading-4">{mapLocaleToMeaningfulFormat().step2AddressTooltip}</li>
        <section className="pl-6 pt-3">
          <ul className="list-none">
            <li className="pb-3">{mapLocaleToMeaningfulFormat().aaAddressTooltip}</li>
            <li className="pb-3">{mapLocaleToMeaningfulFormat().aeAddressTooltip}</li>
            <li className="pb-3">{mapLocaleToMeaningfulFormat().apAddressTooltip}</li>
          </ul>
        </section>
        <li className="pb-2 leading-4">{mapLocaleToMeaningfulFormat().step3AddressTooltip}</li>
        <section className="pl-4">
          <p>{mapLocaleToMeaningfulFormat().examplesAddressTooltip}</p>
          <section className="pl-6 pt-2">
            <ul className="list-disc">
              <li>{mapLocaleToMeaningfulFormat().fpoAAAddressTooltip}</li>
              <li>{mapLocaleToMeaningfulFormat().apoAAAddressTooltip}</li>
              <li>{mapLocaleToMeaningfulFormat().fpoAEAddressTooltip}</li>
              <li>{mapLocaleToMeaningfulFormat().apoAEAddressTooltip}</li>
              <li>{mapLocaleToMeaningfulFormat().fpoAPAddressTooltip}</li>
              <li>{mapLocaleToMeaningfulFormat().apoAPAddressTooltip}</li>
            </ul>
          </section>
        </section>
      </ol>
    </section>
  );
};

export default AddressToolTip;
